import { Grid } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { AppBox, AppTypography, IpText } from 'components'
import { ApiQueryKeys, IpLogType } from 'globals/constants'
import { FC, useCallback, useEffect } from 'react'
import { AdminUserApi } from 'sdk'

interface Props {
  userId: string
}

export const ManageAccountSecurityIPInfoCard: FC<Props> = ({ userId }) => {
  const adminApi = new AdminUserApi()
  const {
    data: logs,
    mutate: getLogs,
    isPending: isGetting,
  } = useMutation({
    mutationKey: [ApiQueryKeys.admin.changeUserRole],
    mutationFn: () => adminApi.getUserIpRecentLogs(userId),
  })
  const getIp = useCallback(
    (type: IpLogType) => {
      return logs?.find((x) => x.Type == type)?.IP
    },
    [logs]
  )

  useEffect(() => getLogs(), [userId])
  return (
    <AppBox backgroundColor="grey.100" border={1} borderColor={'grey.200'} borderRadius={6} padding={2}>
      <AppTypography fontWeight={700} fontSize={16}>
        Security IP Info
      </AppTypography>
      <Grid container>
        <Grid item xs={2.4}>
          <AppBox display={'flex'} gap={2} alignItems={'center'}>
            <AppTypography color={'grey.500'}>Sign Up IP: </AppTypography>
            <IpText isLoading={isGetting} ip={getIp(IpLogType.SignUp)} />
          </AppBox>
        </Grid>
        <Grid item xs={2.4}>
          <AppBox display={'flex'} gap={2} alignItems={'center'}>
            <AppTypography color={'grey.500'}>Last Login IP:</AppTypography>
            <IpText isLoading={isGetting} ip={getIp(IpLogType.Login)} />
          </AppBox>
        </Grid>
        <Grid item xs={2.4}>
          <AppBox display={'flex'} gap={2} alignItems={'center'}>
            <AppTypography color={'grey.500'}>Profile Wizard IP:</AppTypography>
            <IpText isLoading={isGetting} ip={getIp(IpLogType.Profile_Completed)} />
          </AppBox>
        </Grid>
        <Grid item xs={2.4}>
          <AppBox display={'flex'} gap={2} alignItems={'center'}>
            <AppTypography color={'grey.500'}>Profile Updated IP:</AppTypography>
            <IpText isLoading={isGetting} ip={getIp(IpLogType.Profile_Updated)} />
          </AppBox>
        </Grid>
        <Grid item xs={2.4}>
          <AppBox display={'flex'} gap={2} alignItems={'center'}>
            <AppTypography color={'grey.500'}>Change Plan IP:</AppTypography>
            <IpText isLoading={isGetting} ip={getIp(IpLogType.ChangePlan)} />
          </AppBox>
        </Grid>
        <Grid item xs={2.4}>
          <AppBox display={'flex'} gap={2} alignItems={'center'}>
            <AppTypography color={'grey.500'}>Add Payment IP:</AppTypography>
            <IpText isLoading={isGetting} ip={getIp(IpLogType.AddPayment)} />
          </AppBox>
        </Grid>{' '}
        <Grid item xs={2.4}>
          <AppBox display={'flex'} gap={2} alignItems={'center'}>
            <AppTypography color={'grey.500'}>Threat IP:</AppTypography>
            <IpText isLoading={isGetting} ip={getIp(IpLogType.Threat)} />
          </AppBox>
        </Grid>
      </Grid>
    </AppBox>
  )
}
